import { EVENT_NAMES } from "constants/enums";
import { getPageLevelActions, getLastOpenedPage } from "selectors/documentSelectors";
import { getPageActions } from "selectors/pageSelectors";
import { getCurrentPageNumber } from "selectors/pageNumber";
import { executePageActions } from "pdfActionManager/pageActionsHelper";

export const pageChangeHandler = (stores, currentPageNumber) => {
  if (!stores || currentPageNumber === 0) {
    return;
  }
  const lastOpenedPage = getLastOpenedPage(stores);
  if (lastOpenedPage) {
    const pageCloseActions = getPageActions(stores, lastOpenedPage - 1)[EVENT_NAMES.CLOSE] || [];
    executePageActions({ stores, mode: EVENT_NAMES.CLOSE, actions: pageCloseActions });
  }
  stores.documentStore.isPageLoadedPromise(currentPageNumber - 1).then(() => {
    if (getCurrentPageNumber(stores) === currentPageNumber) {
      const pageOpenActions = getPageActions(stores, currentPageNumber - 1)[EVENT_NAMES.OPEN] || [];
      executePageActions({ stores, mode: EVENT_NAMES.OPEN, actions: pageOpenActions });
    }
  });
  stores.documentStore.setLastOpenedPage(currentPageNumber);
};

export const checkPageActionsRequired = (stores, pageIndex) => {
  if (!stores || Object.keys(getPageActions(stores, pageIndex)).length !== 0) {
    return false;
  }
  const pageActions = getPageLevelActions(stores) || { jsAction: {}, nonJSAction: {} };
  const {
    jsAction: { pageIndexes: jsPageIndexes = [] } = {},
    nonJSAction: { pageIndexes: nonJSPageIndexes = [] } = {}
  } = pageActions;
  return jsPageIndexes.includes(pageIndex) || nonJSPageIndexes.includes(pageIndex);
};
